import type { WorkflowIssue } from "./workflow-validation"

export const MAX_AUTO_RETRIES = 3

function formatIssue(issue: WorkflowIssue): string {
  const nodeSuffix = issue.nodeId ? ` (node: ${issue.nodeId})` : ""
  return `- ${issue.message}${nodeSuffix}`
}

export function buildAutoRetryPrompt(
  operationErrors: string[],
  validationErrors: WorkflowIssue[]
): string {
  const sections: string[] = []

  if (operationErrors.length > 0) {
    sections.push(`Operation errors:\n${operationErrors.map((error) => `- ${error}`).join("\n")}`)
  }

  if (validationErrors.length > 0) {
    sections.push(`Validation errors:\n${validationErrors.map(formatIssue).join("\n")}`)
  }

  return (
    "Your last workflow_edit introduced errors. Fix them with the smallest possible workflow_edit operations.\n\n" +
    sections.join("\n\n")
  )
}
